import type { MenuItem } from "./components/sidebar";
import { Paths } from "@/core/constants/paths";
import {
  decodeJwt,
  getAuthToken,
  hasAnyScope,
  isAuthorizedForRule,
  SCOPE_HUB_WEB,
} from "@/modules/auth";

interface MenuItemDefinition extends MenuItem {
  rule?: "admin";
}

const MENU_ITEMS: MenuItemDefinition[] = [
  {
    label: "Início",
    icon: "pi pi-home",
    path: Paths.HOME,
    testId: "nav-inicio",
    scopes: [SCOPE_HUB_WEB],
  },
];

function canAccess(item: MenuItem, token: string | null): boolean {
  if (!item.scopes?.length) return true;
  if (!token) return false;
  if (!decodeJwt(token)?.scope) return true;
  return hasAnyScope(token, item.scopes);
}

export function useMenuItems(): MenuItem[] {
  const token = getAuthToken();
  return MENU_ITEMS.filter(
    ({ rule, ...item }) => (!rule || isAuthorizedForRule(rule)) && canAccess(item, token),
  ).map(({ rule: _rule, ...item }) => item);
}

const SECONDARY_MENU_ITEMS: MenuItemDefinition[] = [
  {
    label: "Painel de Controle",
    icon: "pi pi-cog",
    path: Paths.CONTROL_PANEL,
    testId: "nav-painel-de-controle",
    end: false,
    rule: "admin",
    scopes: [SCOPE_HUB_WEB],
  },
];

export function useSecondaryMenuItems(): MenuItem[] {
  const token = getAuthToken();
  return SECONDARY_MENU_ITEMS.filter(
    ({ rule, ...item }) => (!rule || isAuthorizedForRule(rule)) && canAccess(item, token),
  ).map(({ rule: _rule, ...item }) => item);
}
